export default __webpack_public_path__ + "static/media/Ford-Everest-Trend.28567b8a.png";